import React, { useState,useEffect ,useContext} from 'react';
import PortalHeader from '../components/PortalHeader';
import { useNavigate } from "react-router-dom";
import RegistrationFormThankYou from '../components/RegistrationFormThankYou';
import { AuthContext } from "../context/AuthContext.js";
import { buildUrlWithUTM, extractUTMParameters, storeUTMParameters, getStoredUTMParameters } from '../utils/utmUtils.js';


const PageSuccess = () => {
    const navigate = useNavigate();
    const authContext = useContext(AuthContext);

    // Capture UTM parameters on component mount
    useEffect(() => {
        const utmParams = extractUTMParameters();
        if (utmParams.utm_source || utmParams.utm_medium || utmParams.utm_campaign) {
            storeUTMParameters(utmParams);
            console.log('UTM Parameters captured on success page:', utmParams);
        } else {
            localStorage.removeItem('utm_parameters');
        }
    }, []);

    const handleGotoDashboard = () => {
        navigate(buildUrlWithUTM("/portal/dashboard"));
    }
    const handleLogout = () => {
        // Preserve UTM parameters before logout clears localStorage
        const currentUtmParams = extractUTMParameters();
        const storedUtmParams = getStoredUTMParameters();
        const utmParams = (currentUtmParams.utm_source || currentUtmParams.utm_medium || currentUtmParams.utm_campaign) 
          ? currentUtmParams 
          : storedUtmParams;
        
        console.log('Logout - Current UTM params:', currentUtmParams);
        console.log('Logout - Stored UTM params:', storedUtmParams);
        console.log('Logout - Using UTM params:', utmParams);
        
        authContext.logout();
        console.log("Logout successfully");
        
        // Build URL with UTM parameters directly
        let loginUrl = '/portal/login';
        if (utmParams.utm_source || utmParams.utm_medium || utmParams.utm_campaign) {
          const params = new URLSearchParams();
          if (utmParams.utm_source) params.append('utm_source', utmParams.utm_source);
          if (utmParams.utm_medium) params.append('utm_medium', utmParams.utm_medium);
          if (utmParams.utm_campaign) params.append('utm_campaign', utmParams.utm_campaign);
          loginUrl = `${loginUrl}?${params.toString()}`;
          
          // Restore UTM parameters to localStorage after logout so they persist on login page
          storeUTMParameters(utmParams);
        }
        
        console.log('Logout - Navigating to:', loginUrl);
        // Use window.location.href to ensure URL is updated in browser
        window.location.href = loginUrl;
    }   
    return (
        <>
            <PortalHeader >
                <nav className="nav-links">
                    <a href={buildUrlWithUTM("/portal")} className="nav-link" onClick={(e) => { e.preventDefault(); navigate(buildUrlWithUTM('/portal')); }}>Home</a>
                    <a href={buildUrlWithUTM("/portal/dashboard")} className="nav-link" onClick={(e) => { e.preventDefault(); navigate(buildUrlWithUTM('/portal/dashboard')); }}>Dashboard</a>
                </nav>
                <button className="logout-button" onClick={handleLogout}>Logout</button>
            </PortalHeader>
            <RegistrationFormThankYou />
            {/* <div className="form-footer">
                <button
                    type="button"
                    className="back-button"
                    onClick={handleGotoDashboard}
                >
                    Go to Dashboard
                </button>
            </div> */}
        </>
    );
}

export default PageSuccess;

